import VXEStore from './store';
export var validators = new VXEStore();
if (process.env.NODE_ENV === 'development') {
    Object.assign(validators, { _name: 'Validators' });
}
